import styled from "styled-components";
import { RaceResultHeaderProps } from "./type";

export const RaceResultContainer = styled.div``;

export const RaceResultHeader = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.space["space-4"]};
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const RaceResultHeaderBets = styled.div<
  Pick<RaceResultHeaderProps, "numberOfColumns">
>`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfColumns }) => numberOfColumns},
    80px
  );
  justify-items: end;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  height: 44px;
`;

export const RaceResultTextContainer = styled.div``;
